import styled from 'styled-components';
import {
  Dialog,
} from '@mui/material';

import { ReactComponent as CloseButtonIcon } from '../../assets/icons/close-thread-icon.svg';
import { ReactComponent as ChatIcon } from '../../assets/icons/chat-icon.svg';
import colors from '../../styles/colors';

const Container = styled.div`
  position: relative;
  align-items: center;
  justify-content: center;
  border: 1px solid ${colors.shades.secondary5};
  border-radius: 20px;
  background: ${colors.shades.secondary5};
  padding: 20px 0;
  min-width: 900px;
  cursor: move;
`;

const StyledChatIcon = styled(ChatIcon)`
  width: 20px;
  height: 20px;
  > path {
    stroke: ${({ $light }) => ($light ? colors.base.secondary2 : colors.base.primary)};
    fill: ${({ $light }) => ($light ? colors.base.secondary3 : colors.shades.beta2)};
  }
`;

const CloseButton = styled(CloseButtonIcon)`
  width: 40px;
  height: 40px;
  position: absolute;
  right: -20px;
  top: -20px;
  z-index: 1;
  cursor: pointer;
`;

const ModalHeader = styled.div`
  padding: 8px 32px 24px 32px;
`;

// scrollbar-gutter here DOES NOT WORK on SAFARI
const ModalContent = styled.div`
  max-height: 80vh;
  overflow-y: auto;
  scrollbar-gutter: stable both-edges;
  padding: 0 20px;
`;

const StyledModal = styled(Dialog)`
  .MuiDialog-paper {
    overflow: visible;
    align-items: center;
    border-radius: 20px;
    }
`;

const ModalContainer = styled.div`
  align-items: center;
  justify-content: center;
`;

export {
  StyledModal,
  Container,
  CloseButton,
  ModalHeader,
  ModalContent,
  StyledChatIcon,
  ModalContainer,
};
